import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import RatioContainer from 'components/consumer/RatioContainer';

import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import useScreen from 'hooks/useScreen';

const PDPFullScreenGalleryListItem = ({
  closeFullScreenGallery,
  cropData,
  displayShownIn = false,
  enableCrops,
  type,
  is2MobileColumns,
  isEditOrder,
  isMobile,
  onClick,
  optionId,
  productName = null,
  src,
  upholsteryName,
  valueId,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  // This component is only used within PDPFullScreenGallery which only renders
  // in the browser, so it is safe to conditionally render elements using media
  // queries here
  const { isTabletOrDesktop } = useScreen();

  const ImageWrapper = isMobile && is2MobileColumns ? RatioContainer : Fragment;

  const desktopImageSizesProps = useFixedWidthContainerSizeProps();
  const mobileImageSizesProps = { sizes: '100vw' };

  const imageSizesProps = isTabletOrDesktop
    ? desktopImageSizesProps
    : mobileImageSizesProps;

  return (
    <div className="relative">
      <ImageWrapper>
        <JBProductImage
          className={cx('mx-auto my-0', {
            'max-[767px]:bottom-0 max-[767px]:h-full max-[767px]:left-0 max-[767px]:object-contain max-[767px]:absolute max-[767px]:right-0 max-[767px]:top-0': is2MobileColumns,
          })}
          crops={cropData}
          isFullScreenGallery
          src={src}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...imageSizesProps}
          enableCrops={enableCrops}
          type={type}
          ar={is2MobileColumns ? '1:1' : undefined}
          cropFormat={is2MobileColumns ? '1x1' : null}
          onClick={onClick}
          onLoad={isFail => !isFail && setIsImageLoaded(true)}
        />
        {((isTabletOrDesktop &&
          isImageLoaded &&
          optionId &&
          valueId &&
          upholsteryName) ||
          (displayShownIn && upholsteryName && optionId && isImageLoaded)) && (
          <div
            className={cx('bg-white right-0 bottom-0 p-2.5 rounded-none', {
              absolute: !(isMobile && displayShownIn),
              static: isMobile && displayShownIn,
            })}
          >
            <PDPShownIn
              isEditOrder={isEditOrder}
              optionId={optionId}
              valueId={valueId}
              upholsteryName={upholsteryName}
              onSelection={closeFullScreenGallery}
              productName={productName}
              layout={isMobile && displayShownIn ? 'roundSwatchLabel' : ''}
              showInactiveUpholstery={isMobile && displayShownIn}
            />
          </div>
        )}
      </ImageWrapper>
    </div>
  );
};

PDPFullScreenGalleryListItem.propTypes = {
  closeFullScreenGallery: PropTypes.func,
  cropData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  is2MobileColumns: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func,
  optionId: PropTypes.number,
  productName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  src: PropTypes.string,
  type: PropTypes.string,
  upholsteryName: PropTypes.string,
  valueId: PropTypes.number,
};

export default PDPFullScreenGalleryListItem;
